import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const WithdrawalConfirmed = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const successParam = params.get("success") === "true";
    const messageParam = params.get("message") || "";

    setSuccess(successParam);
    setMessage(messageParam);

    // Redirect to dashboard after 5 seconds
    setTimeout(() => {
      navigate("/dashboard");
    }, 5000);
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 text-center">
          <div
            className={`w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 ${
              success ? "bg-emerald-500/20" : "bg-rose-500/20"
            }`}
          >
            {success ?
              <FaCheckCircle className="text-4xl text-emerald-400" />
            : <FaTimesCircle className="text-4xl text-rose-400" />}
          </div>

          <h1 className="text-2xl font-bold text-white mb-3">
            {success ? "Withdrawal Confirmed!" : "Confirmation Failed"}
          </h1>

          <p className="text-slate-300 mb-6">
            {success ?
              "Your withdrawal has been confirmed and will be processed by our team shortly."
            : message ||
              "Failed to confirm withdrawal. The link may be invalid or expired."
            }
          </p>

          <div
            className={`text-sm p-4 rounded-lg mb-6 ${
              success ?
                "bg-emerald-500/10 border border-emerald-500/20 text-emerald-200"
              : "bg-rose-500/10 border border-rose-500/20 text-rose-200"
            }`}
          >
            {success ?
              "Processing time: 2-24 hours. You'll receive an email once completed."
            : "If you need assistance, please contact support."}
          </div>

          <button
            onClick={() => navigate("/dashboard")}
            className="btn-primary w-full"
          >
            Go to Dashboard
          </button>

          <p className="text-xs text-slate-500 mt-4">
            Redirecting in 5 seconds...
          </p>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalConfirmed;
